import React from 'react';
import Utils from './../../utils/Validate'
 
const InputText = ({name, value,placeholder,type,onChange, onBlur, validate, onKeyDown , minLength, maxLength, alias, origen, mensaje, disabled, clase = undefined, ismap = undefined, tabindex = "0",onKeyUp }) =>
    <div /*id={ismap ? ismap : placeholder}*/ className={(clase || '')+" input-field"}>
        <input
            tabIndex={tabindex}
            minLength={minLength}
            maxLength={maxLength}
            id={ismap ? ismap : placeholder}
            type={type || "text" } 
            name={name}
            disabled={disabled}
            // onKeyDown={onKeyDown ? onKeyDown : ()=> {console.log()} } 
            // onKeyUp={onKeyUp ? onKeyUp : ()=> {console.log()} } 
            value={value}
            autoComplete="new-password"
            className= {"validate " + (validate === false ? 'input-error' : '') + (disabled ? 'disabled' : '') }
            onChange = { (e) => { onChange(e) }}
            onBlur={ (e) => onBlur(e) } />            
        <label className={value? 'active ': ''} htmlFor={ismap ? ismap : placeholder}>{placeholder}</label>
        {(validate === false && origen!=='login') ? <span className="message-error">* Ingrese un(a) {Utils.convertirMinusculas(alias || placeholder)} válido(a)</span> : null} 
        {(validate === false && origen==='login' && mensaje !== '') ? <span className="message-error">* {mensaje}</span> : null} 
        {(validate === true && origen==='login' && mensaje !== '') ? <span className="message-success">* {mensaje}</span> : null} 
	</div>

export default InputText;